import { useEffect, useMemo } from 'react';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { useSetOnboardingState } from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { fg } from '@confluence/feature-gating';
import { NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

import { getNthUserOnboardingActionsData } from '../nth-user-home-onboarding/cards/NthUserCards.tsx';

export const useNthUserActions = (dismissedCardIds: Set<string>) => {
	const { isRovoEnabled, isRovoLLMEnabled } = useSessionData();
	const shouldShowRovo = fg('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;

	const { setOnboardingState } = useSetOnboardingState();

	const actionCardsToDisplay = useMemo(() => {
		const isCardDismissed = (cardId: string) => dismissedCardIds.has(cardId);
		const shouldShowCard = (cardId: string) => {
			if (isCardDismissed(cardId)) return false;
			if (cardId === 'meetAITeammate') return shouldShowRovo;
			if (cardId === 'followPeopleAndSpaces') return !shouldShowRovo;
			return true;
		};
		return getNthUserOnboardingActionsData().filter((card) => shouldShowCard(card.id));
	}, [dismissedCardIds, shouldShowRovo]);

	useEffect(() => {
		if (actionCardsToDisplay.length === 0) {
			setOnboardingState({
				key: NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS.areAllActionsDismissed,
				value: 'true',
			});
		}
	}, [actionCardsToDisplay, setOnboardingState]);

	return {
		areAllActionsDismissed: actionCardsToDisplay.length === 0,
		actionCardsToDisplay,
	};
};
